import { defineStore } from 'pinia'

export const useSiteHeaderStore = defineStore('site-header', {
  state: () => ({
    forceShow: false,
  }),
})
